export enum ProductType {
    Kite = 'kite',
    Board = 'board',
    Bar = 'bar'
}